import { FC } from "react";
import SearchBox from "../../../../components/components-library/searchbox";
import ONOCalendarV2 from "../../../../components/commons/ono-calendar-v2/ono_calendar_v2";
import FilterButton from "../../../../components/ui/filter_button/FilterButton";
import RefreshButton from "../../../../components/ui/refresh_button/RefreshButton";
import PayoutsTable from "./PayoutsTable";
import ToggleCard from "../../../../components/toggle-cards/toggle_card";
import payments from "../../../../assets/images/payments_circled.svg";
import { getCurrencyNumberWithSymbol } from "../../../../helpers/get-currency-number";
import usePayouts from "../bloc/usePayouts";
import PayoutViewPage from "../../payout_view/ui/PayoutViewPage";
import PayoutFilterView from "../payout_filter/ui/PayoutFilterView";
import excel from "../../../../assets/images/excel.svg";

const PayoutsPage: FC<{}> = () => {
  const {
    searchText,
    setSearchText,
    calendarDate,
    payouts,
    onChangeDate,
    onRefresh,
    onClickPayout,
    payoutSummary,
    isCollapsed,
    setIsCollapsed,
    showPayoutView,
    setShowPayoutView,
    showFilters,
    setShowFilters,
    filters,
    isFilterApplied,
    handlePayoutsExport,
  } = usePayouts();

  return (
    <div className="p-20">
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1">
          <SearchBox
            className="mr-2"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            placeholder={"Search by UTR / Receiver / Payout ID"}
          />
        </div>
        <div className="flex flex-1 justify-center">
          <ONOCalendarV2
            mode={calendarDate.mode}
            onChangeDate={(fromDate, toDate, mode) => {
              onChangeDate(fromDate, toDate, mode);
            }}
            fromDate={calendarDate.fromDate}
            toDate={calendarDate.toDate}
          />
        </div>
        <div className="flex flex-1 justify-end gap-2">
          <button
            className="flex items-center text-sm gap-2 bg-primary text-white px-4 py-2 rounded-full justify-end"
            onClick={() => {
              handlePayoutsExport();
            }}
          >
            <img src={excel} alt="" className="h-6 w-6" />
            Export to Excel
          </button>
          <RefreshButton onClick={onRefresh} />
          <FilterButton
            onClick={() => {
              setShowFilters(true);
            }}
            isFilterApplied={isFilterApplied()}
          />
        </div>
      </div>
      <div className="mt-5">
        <ToggleCard
          list={[
            {
              label: "Total Payout",
              value: getCurrencyNumberWithSymbol(payoutSummary.total, true),
              icon: payments,
            },
            {
              label: "Number Of Payouts",
              value: payoutSummary.noOfPayouts.toString(),
              icon: payments,
            },
            {
              label: "Pending Transactions",
              value: payoutSummary.pendingTransactions.toString(),
              icon: payments,
            },
          ]}
          onClick={(val) => {
            setIsCollapsed(!isCollapsed);
          }}
        />
      </div>
      <div className="mt-5">
        <PayoutsTable
          searchText={searchText}
          payouts={payouts}
          onClick={onClickPayout}
          isCardCollpased={isCollapsed}
          filters={filters}
        />
      </div>
      {showPayoutView && (
        <PayoutViewPage
          open={showPayoutView}
          onClose={() => {
            setShowPayoutView(false);
          }}
        />
      )}
      {showFilters && (
        <PayoutFilterView
          open={showFilters}
          onClose={() => {
            setShowFilters(false);
          }}
        />
      )}
    </div>
  );
};

export default PayoutsPage;
